import { locationEnums } from '../../../appSettings';

export const secondaryClassificationBadges = (selectedSecondaryClassifications, availableRawClassifications, onHandleSecondaryClassificationSelect) => {
  if (!selectedSecondaryClassifications) return [];

  return selectedSecondaryClassifications.map(classification => {
    const { displayName, code } = availableRawClassifications[classification];
    return {
      displayName,
      id: code,
      handleDelete: () => { onHandleSecondaryClassificationSelect(classification) },
    };
  });

}

export const hotelProductBadges = (selectedHotelProducts, hotelProducts, onHandleHotelProductSelect) => {
  if (!selectedHotelProducts) return [];

  return selectedHotelProducts.map((hotelProduct) => {
    const { displayName, code } = hotelProducts[hotelProduct];
    return {
      displayName,
      id: code,
      handleDelete: () => { onHandleHotelProductSelect(hotelProduct) },
    };
  })
}

export const conceptHotelBadges = (selectedConceptHotels, conceptHotels, onHandleConceptHotelSelect) => {
  if (!selectedConceptHotels) return [];

  return selectedConceptHotels.map((conceptHotel) => {
    const { displayName, code } = conceptHotels[conceptHotel];
    return {
      displayName,
      id: code,
      handleDelete: () => { onHandleConceptHotelSelect(conceptHotel) },
    };
  })
}

export const hotelRatingBadges = (selectedRatings, onHandleRatingSelect, labels) => {
  if (!selectedRatings) return [];

  return selectedRatings.map((rating) => {
    return {
      displayName: `${labels.accommodationFilterRating}: ${rating}`,
      id: rating,
      handleDelete: () => { onHandleRatingSelect(rating) },
    };
  })
}

export const locationBadges = (selectedLocations, onHandleLocationSelect, labels) => {
  if (!selectedLocations) return [];

  return selectedLocations.filter(location => location !== locationEnums.ANYWHERE).map((location) => {
    return {
      displayName: labels[location],
      id: location,
      handleDelete: () => { onHandleLocationSelect(location) },
    };
  })
}

export const temperatureBadge = (selectedTemperature, onHandleTemperatureSelect, labels) => {
  if (!selectedTemperature) return [];

  return [{
    displayName: labels[`temp_${selectedTemperature}`],
    id: selectedTemperature,
    handleDelete: () => { onHandleTemperatureSelect(null) },
  }];
}

export const temperaturePeriodBadge = (selectedTemperaturePeriod, onHandleTemperaturePeriodSelect, labels) => {
  if (!selectedTemperaturePeriod) return [];

  return [{
    displayName: labels[selectedTemperaturePeriod],
    id: selectedTemperaturePeriod,
    handleDelete: () => { onHandleTemperaturePeriodSelect(null) },
  }];
}

export const flightTimeBadge = (selectedFlightTime, onHandleFlightTimeSelect, labels) => {
  if (!selectedFlightTime) return [];

  const flightPrefix = labels.flightTime;
  const flightSuffix = labels[`flight_${selectedFlightTime}`];
  return [{
    displayName: `${flightPrefix} ${flightSuffix}`,
    id: labels.flightTime,
    handleDelete: () => { onHandleFlightTimeSelect(null) },
  }];
}

export const paxAdultsBadge = (pax, onHandleNumberOfAdultsSelect, labels) => {
  return [{
    displayName: `${labels.paxPickerAdult}: ${pax.selectedNumberOfAdults}`,
    id: labels.paxPickerAdult,
    handleDelete: () => { onHandleNumberOfAdultsSelect(2) },
    canDelete: pax.selectedNumberOfAdults !== 2, // don't allow deletion of the default value
  }];
}

export const paxChildrenBadge = (pax, onHandleNumberOfChildrenSelect, labels) => {
  if (pax.selectedNumberOfChildren === 0) return [];

  return [{
    displayName: `${labels.paxPickerChild}: ${pax.selectedNumberOfChildren}`,
    id: `pax_children_${pax.selectedNumberOfChildren}`,
    handleDelete: () => { onHandleNumberOfChildrenSelect(0) },
  }];
}

export const airportBadge = (pax, departureAirports, onHandleDepartureSelect, labels) => {
  const airportPrefix = labels.paxPickerDepartureLocation.charAt(0).toUpperCase() + labels.paxPickerDepartureLocation.slice(1).toLowerCase();
  const airportSuffix = departureAirports.find(airport => airport.value === pax?.selectedDeparture)?.name || departureAirports[0]?.name; 
  return [{
    displayName: `${airportPrefix}: ${airportSuffix}`,
    id: `${airportSuffix}`,
    handleDelete: () => { onHandleDepartureSelect(departureAirports[0].value, departureAirports[0].caIdDict) },
    canDelete: pax.selectedDeparture !== departureAirports[0].value, // don't allow deletion of the default value
  }];
}

export const departureMonthBadges = (selectedDepartureMonths, onHandleDepartureMonthsSelect, labels) => {
  if (!selectedDepartureMonths) return [];

  return selectedDepartureMonths.map(monthString => {
    const year = monthString.substring(0,4);
    const month = monthString.substring(4,6);
    return {
      displayName: `${labels.hotelDeparture}: ${year}-${month}`,
      id: month,
      handleDelete: () => { onHandleDepartureMonthsSelect(selectedDepartureMonths.filter(selectedMonths => selectedMonths !== monthString)) },
    };
  })
}